// @ts-strict-ignore
import { createContext } from "react";

interface StaticData {
  adminImpersonating: boolean;
  patientTerm: string;
  taxComplianceEmail: string;
  taxComplianceFaxNumber: string;
  taxExemptionEligibilityUrl: string;
  treatmentPlanTerm: string;
  fsWholesaleEnabled: boolean;
  labsAuthNetworkFee?: number;
}

const DefaultStaticData: StaticData = {
  adminImpersonating: false,
  patientTerm: "",
  taxComplianceEmail: "",
  taxComplianceFaxNumber: "",
  taxExemptionEligibilityUrl: "",
  treatmentPlanTerm: "",
  fsWholesaleEnabled: false,
  labsAuthNetworkFee: null,
};

const StaticDataContext = createContext<StaticData>(DefaultStaticData);

export type { StaticData };
export { StaticDataContext, DefaultStaticData };
